import { useContext } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import AppRouter from './pages';
import { AuthContext } from './context/Auth/Auth';
import ErrorBoundary from './components/Errorboundary/Errorboundary';
import Footer from './components/Footer/Footer';
import Navbar from './components/Navbar/Navbar';
import Spinner from './components/Spinner/Spinner';

const FULL_SCREEN_PATHS = ['/login', '/signup'];

const AppShell = () => {
  const { pathname } = useLocation();
  const isFullScreen = FULL_SCREEN_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));

  return (
    <div className={isFullScreen ? 'app-shell app-shell--full-screen' : 'app-shell'}>
      {!isFullScreen && <Navbar />}
      <main className="app-main" id="contenido-principal">
        <ErrorBoundary>
          <AppRouter />
        </ErrorBoundary>
      </main>
      {!isFullScreen && <Footer />}
    </div>
  );
};

const App = () => {
  const { isLoading } = useContext(AuthContext);

  if (isLoading) return <Spinner fullPage label="Cargando sitio" />;

  return (
    <Router>
      <AppShell />
    </Router>
  );
};

export default App;
